import { DataGrid } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import { useSidebarCounts } from "../context/SidebarCountsContext";
import axiosInstance from "../utils/axiosInstance";
import CustomToolbar from "./CustomToolbar";

export default function CustomTable({ columns, fetchDataUrl, refresh }) {
  const { updateCount } = useSidebarCounts();

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchTerm] = useState("");
  const [sortBy, setSortBy] = useState();
  const [sortOrder, setSortOrder] = useState("asc");
  const [loading, setLoading] = useState(false);
  const [metadata, setMetadata] = useState();
  const [data, setData] = useState([]);

  const handleSortModelChange = useCallback((sortModel) => {
    if (sortModel && sortModel.length > 0) {
      setSortBy(sortModel[0].field);
      setSortOrder(sortModel[0].sort);
    } else {
      setSortBy(null);
      setSortOrder(null);
    }
  }, []);

  const handlePaginationModelChange = useCallback((paginationModel) => {
    setCurrentPage(paginationModel.page + 1);
    setPerPage(paginationModel.pageSize);
  }, []);

  const fetchData = useCallback(
    async (
      page = 1,
      pageSize = 10,
      searchTerm,
      sort_order = "asc",
      sort_by,
    ) => {
      setLoading(true);
      let searchQuery = searchTerm ? `&search=${searchTerm}` : "";
      let sortByQuery = sort_by ? `&sortBy=${sort_by}` : "";
      let sortOrderQuery = sort_order ? `&sortOrder=${sort_order}` : "";
      try {
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_API_URL}/${fetchDataUrl}?page=${page}&pageSize=${pageSize}${searchQuery}${sortByQuery}${sortOrderQuery}`,
        );

        if (response.status === 200) {
          setMetadata(response.data);
          setData(response.data.data);
          setLoading(false);
          updateCount();
        }
      } catch (error) {
        console.error("Error fetching most downloaded PDFs", error);
      }
    },
    [fetchDataUrl, updateCount],
  );

  useEffect(() => {
    fetchData(currentPage, perPage, searchTerm, sortOrder, sortBy);
  }, [currentPage, fetchData, perPage, searchTerm, sortBy, sortOrder, refresh]);

  return (
    <>
      {metadata && (
        <DataGrid
          autoHeight
          loading={loading}
          rows={data}
          columns={columns}
          rowSelection={false}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
          }
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
          }}
          pageSizeOptions={[5, 10, 15, 20, 50, 100]}
          sortingMode="server"
          onSortModelChange={handleSortModelChange}
          paginationMode="server"
          onPaginationModelChange={handlePaginationModelChange}
          rowCount={metadata.total}
          density="compact"
          slots={{
            toolbar: () => (
              <CustomToolbar
                onRefresh={() => {
                  fetchData(
                    currentPage,
                    perPage,
                    searchTerm,
                    sortOrder,
                    sortBy,
                  );
                }}
              />
            ),
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
            },
            filterPanel: {
              filterFormProps: {
                logicOperatorInputProps: {
                  variant: "outlined",
                  size: "small",
                },
                columnInputProps: {
                  variant: "outlined",
                  size: "small",
                  sx: { mt: "auto" },
                },
                operatorInputProps: {
                  variant: "outlined",
                  size: "small",
                  sx: { mt: "auto" },
                },
                valueInputProps: {
                  InputComponentProps: {
                    variant: "outlined",
                    size: "small",
                  },
                },
              },
            },
            loadingOverlay: {
              variant: "skeleton",
              noRowsVariant: "skeleton",
            },
          }}
        />
      )}
    </>
  );
}
